import { RootState, SasToken } from 'gf-types';
import { useEffect, useState } from 'react';
import { cropImage, loadImage } from '../helpers/ImageUtility';
import { useAppSelector } from '../hooks/ReduxHooks';

export function useCroppedBackground(backgroundCropDimensions) {
  const [croppedImage, setCroppedImage] = useState('');

  const pages = useAppSelector<TypeMePlease[]>((state: RootState) => state.formeditor.template?.pages);
  const sasToken = useAppSelector<SasToken>((state: RootState) => state.shared.sasToken);
  const fileUrls = useAppSelector<Record<string, string>>((state: RootState) => state.formeditor.fileUrls);

  const getFilePath = (fileId: string) => {
    if (fileUrls) {
      return fileUrls[fileId];
    }
    return `${sasToken.baseUrl}${fileId}${sasToken.token}`;
  };

  const getCroppedBackground = async () => {
    const { x, y, w, h, pageNumber } = backgroundCropDimensions;
    const fileId = pages.find((page) => page.number === pageNumber).fileId;
    const imageData = getFilePath(fileId);
    const image = await loadImage(imageData, true);
    const badDimensions = x > image.width || y > image.height;
    const croppedImg = badDimensions ? null : await cropImage(image, x, y, w, h);
    setCroppedImage(croppedImg);
  };

  useEffect(() => {
    if (backgroundCropDimensions) {
      getCroppedBackground();
    }
  }, [backgroundCropDimensions]);

  return croppedImage;
}
